module.exports = __webpack_public_path__ + "static/img/result_error.bf7ed788.png";